<template>
    <div ref="slot2_container" class="pub-container-fixed-bottom">
        <ActionButton v-if="AccountController.account.premium.allowed "
            v-tooltip='"messages.ads.tooltip_remove"'
            :gtm="{
                module : 'ads',
                feature: 'ads_remove_modal',
                block  : 'message_list',
                action : 'open'
                }"
            class="close"
            icon="fas fa-times-circle"
            type="icon"
            @click="onRemoveAds()"
        />
        <div class="wrapper">
            <div v-show="slot_item.getFallbackVisibility() === false"
                :id="AdsSlots.GPT_INLINE_BANNER_320_SLOT_2"
                class="GPT_INLINE_BANNER_320_SLOT_2"
            ></div>
            <img v-show="slot_item.getFallbackVisibility() === true"
                :src="slot_item.getFallbackSrc()"
                class="GPT_INLINE_BANNER_320_SLOT_2_FALLBACK"
                alt=""
                @click="onFallbackClick()"/>
        </div>
    </div>

</template>

<script setup>
    import ActionButton              from '@/vue/Elements/Buttons/ActionButton.vue';
    import AccountController         from '@/js/Webmail/AccountController';
    import AdsSlotObserverController from '@/js/Webmail/Ads/AdsSlotObserverController';
    import { ref }                   from 'vue';
    import { onBeforeUnmount }       from 'vue';
    import { onMounted }             from 'vue';
    import { reactive }              from 'vue';
    import DomController             from '@/js/Webmail/DomController';
    import AdsSlots                  from '@/js/Webmail/Ads/AdsSlots';
    import GPTAdsController          from '@/js/Webmail/Ads/GPTAdsController';
    import SlotItem                  from '@/js/Webmail/Ads/Items/SlotItem';
    import SAPOMailConfig            from '../../../SAPOMailConfig.js';

    const slot2_container = ref();
    /** @type {SlotItem} */
    const slot_item       = reactive(new SlotItem());

    const emit = defineEmits(['removeAds']);

    onMounted(() => {
        slot_item.setId(AdsSlots.GPT_INLINE_BANNER_320_SLOT_2);
        slot_item.setElement(slot2_container.value);

        DomController.setBodyClass('hasPub');

        GPTAdsController.addQueue(slot_item);
    });

    onBeforeUnmount(() => {
        GPTAdsController.removeQueue(slot_item);
    });

    const onRemoveAds = () => {
        emit('removeAds');
    };

    const onFallbackClick = () => {
        if (
            SAPOMailConfig.client.ads
            && SAPOMailConfig.client.ads.fallback
            && SAPOMailConfig.client.ads.fallback.links
            && SAPOMailConfig.client.ads.fallback.links.subscricoes
        ) {
            window.open(SAPOMailConfig.client.ads.fallback.links.subscricoes, '_blank');
        }
    };
</script>

<style>
    .pub-container-fixed-bottom .close {
        position: absolute;
        top: 0;
        right: 0;
        padding: 1px;
        z-index: 1;
    }

    .pub-container-fixed-bottom .wrapper {
        display: flex;
        place-content: center;
    }

    .pub-container-fixed-bottom:has(#GPT_INLINE_BANNER_320_SLOT_2)::before {
        content: "Pub";
        position: absolute;
        top: 50%;
        left: 2px;
        transform: translateY(-50%);
        z-index: 1;
        font-family: sans-serif;
        font-size: 9px;
        text-transform: uppercase;
        color: #999;
    }

    .pub-container-fixed-bottom:has(#GPT_INLINE_BANNER_320_SLOT_2) .wrapper {
        width: calc(100% - 60px);
        min-width: 0;
        height: 100%;
        margin-left: 30px;
        padding-left: 0;
        justify-items: center;
        overflow: hidden;
    }

    /* desliga a label do has-pub (.wrapper:before); usamos a do container acima */
    .pub-container-fixed-bottom:has(#GPT_INLINE_BANNER_320_SLOT_2) .wrapper::before {
        content: none;
    }

    .GPT_INLINE_BANNER_320_SLOT_2 {
        place-content: center;
    }

    .GPT_INLINE_BANNER_320_SLOT_2_FALLBACK {
        display: block;
        max-width: 100%;
        cursor: pointer;
    }
</style>
